import React, { useState, useEffect } from 'react';
import './Toast.css';

let toastContainer = null;

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isRemoving, setIsRemoving] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRemoving(true);
      setTimeout(onClose, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClose = () => {
    setIsRemoving(true);
    setTimeout(onClose, 300);
  };

  return (
    <div className={`toast ${type} ${isRemoving ? 'removing' : ''}`}>
      <span className="toast-message">{message}</span>
      <button className="toast-close" onClick={handleClose}>×</button>
    </div>
  );
};

// Function to show toast notifications
export const showToast = (message, type = 'success', duration = 3000) => {
  // Create container if it doesn't exist
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.className = 'toast-container';
    document.body.appendChild(toastContainer);
  }

  // Create a wrapper for the React component
  const toastWrapper = document.createElement('div');
  toastContainer.appendChild(toastWrapper);

  // Render the toast
  const root = require('react-dom/client').createRoot(toastWrapper);
  
  const removeToast = () => {
    root.unmount();
    toastWrapper.remove();
    
    // Remove container if no more toasts
    if (toastContainer && toastContainer.children.length === 0) {
      toastContainer.remove();
      toastContainer = null;
    }
  };

  root.render(
    <Toast 
      message={message} 
      type={type} 
      duration={duration} 
      onClose={removeToast}
    />
  );
};

export default Toast;
